// src/docs/api/groups/suprimentosEndpoints.ts
import type { ApiEndpoint } from "../apiDocsSchema";

export const recursoshumanosEndpoints: ApiEndpoint[] = [
  {
    group: "Recursos Humanos",
    name: "Empresas Cadastradas",
    method: "GET",
    path: "/geral/empresa-clientes-completo",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,

    examples: [
      {
        title: "Exemplo de resposta (200)",

        response: {
          ok: true,
          meta: {
            filtros: {
              q: null,
              ativo: null,
              date_from: null,
              date_to: null,
              order_by: "atualizado_em",
              order: "desc",
              limit: 10000,
              offset: 0,
            },
            count: 33,
            data: [
              {
                id: "37",
                razao_social: "BARCAS RIO",
                nome_fantasia: "BARCAS RIO",
                cnpj: "58750870000168",
                ie: null,
                email: "pendente@gmail.com",
                telefone: "111111111111",
                endereco_logradouro: "n/a",
                endereco_numero: "n/a",
                endereco_bairro: "n/a",
                endereco_cidade: "n/a",
                endereco_uf: "n/",
                endereco_cep: "n/a",
                ativo: true,
                criado_em: "2025-11-19T16:38:21.343Z",
                atualizado_em: "2025-11-19T16:42:08.010Z",
                colaborador_interno_responsavel: [25],
                responsaveis_nomes: ["Karolinne do Carmo"],
              },
            ],
          },
        },
      },
    ],
  },
  {
    group: "Recursos Humanos",
    name: "Colaboradores",
    method: "GET",
    path: "/departamentos/recursos-humanos/colaboradores-completo",
    description:
      "Retorna a lista de produtos visíveis para o departamento de suprimentos.",
    authRequired: true,
    developed: false,

    examples: [
      {
        title: "Exemplo de resposta (200)",
        response: {
          ok: true,
          versao: 3,
          produtos: [
            {
              id: 1,
              codigo: "CABO-COsssAX-50R",
              nome: "Cabo coaxial 50Ω",
              posicao: "A1-01",
            },
          ],
        },
      },
    ],
  },
];
